import { useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { PAGES, TRAINING_DROPDOWN } from "../data/constants";
import { C } from "../theme/colors";

// Maps each nav label to its real URL path
const PAGE_ROUTES = {
  "Home": "/",
  "About": "/about",
  "Stakeholders": "/stakeholders",
  "Research": "/research",
  "Mission": "/mission",
  "Training": "/training",
  "Objectives": "/objectives",
  "Way Forward": "/way-forward",
  "Events": "/events",
  "Contact Us": "/contact",
};

export default function Navbar() {
  const [scrolled,    setScrolled]    = useState(false);
  const [mobileOpen,  setMobileOpen]  = useState(false);
  const [trainDrop,   setTrainDrop]   = useState(false);
  const dropRef = useRef(null);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    const fn = e => { if (dropRef.current && !dropRef.current.contains(e.target)) setTrainDrop(false); };
    document.addEventListener("mousedown", fn);
    return () => document.removeEventListener("mousedown", fn);
  }, []);

  const handleTrainingItem = (sub) => {
    navigate(sub === "overview" ? "/training" : `/training/${sub}`);
    setTrainDrop(false);
    setMobileOpen(false);
  };

  // "Active" check: exact match for most pages, prefix match for Training (covers /training/cybersecurity too)
  const isActive = (label) => {
    const path = PAGE_ROUTES[label];
    if (label === "Training") return location.pathname.startsWith("/training");
    return location.pathname === path;
  };

  return (
    <nav style={{position:"fixed",top:0,left:0,right:0,zIndex:200,background:C.navyDark,borderBottom:`1px solid rgba(255,255,255,0.08)`,boxShadow:scrolled?"0 2px 20px rgba(0,0,0,0.25)":"none",transition:"all .3s",padding:"0 40px"}}>
      <div style={{maxWidth:1260,margin:"0 auto",display:"flex",alignItems:"center",justifyContent:"space-between",height:66}}>
        <Link to="/" style={{background:"none",border:"none",cursor:"pointer",display:"flex",alignItems:"center",gap:12,textDecoration:"none"}}>
          <div style={{width:38,height:38,borderRadius:"50%",background:C.navy,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,overflow:"hidden",border:`2px solid ${C.goldLight}`}}>
            <img
              src="/uploads/crens_logo_final 1.png"
              alt="CRENS Logo"
              style={{
                width: 28,
                height: 28,
                objectFit: "contain",
              }}
            />
          </div>
            <div style={{textAlign:"left"}}>
            <div className="navbar-title" style={{fontFamily:"Arial,Helvetica,sans-serif",fontWeight:700,fontSize:16,color:C.white,letterSpacing:0.3,lineHeight:1.2}}>CRENS @ BITS Pilani</div>
            <div className="navbar-subtitle" style={{fontFamily:"Arial,Helvetica,sans-serif",fontSize:11,color:"rgba(255,255,255,0.65)",letterSpacing:0.2,lineHeight:1.3,marginTop:2}}>Centre for Research Excellence in National Security</div>
          </div>
        </Link>

        <div className="desktop-nav" style={{display:"flex",gap:2,alignItems:"center"}}>
          {PAGES.map(p => {
            if (p === "Training") {
              const active = isActive("Training");
              return (
                <div key={p} ref={dropRef} style={{position:"relative"}}>
                  <button
                    className={`nav-item${active?" active":""}`}
                    onClick={() => setTrainDrop(o => !o)}
                    style={{
                      display:"flex",
                      alignItems:"center",
                      gap:5,
                      color: active ? C.goldLight : "rgba(255,255,255,0.85)",
                      paddingBottom:6,
                      borderBottom: active ? `2px solid ${C.goldLight}` : "2px solid transparent",
                      transition:"border-color .2s, color .2s",
                    }}
                    onMouseEnter={e=>{ if(!active){ e.currentTarget.style.borderBottomColor = C.goldLight; e.currentTarget.style.color = C.goldLight; } }}
                    onMouseLeave={e=>{ if(!active){ e.currentTarget.style.borderBottomColor = "transparent"; e.currentTarget.style.color = "rgba(255,255,255,0.85)"; } }}
                  >
                    Training
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none"
                      style={{transform: trainDrop ? "rotate(180deg)" : "rotate(0deg)", transition:"transform .2s", flexShrink:0}}>
                      <path d="M2 4l4 4 4-4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </button>
                  {trainDrop && (
                    <div style={{position:"absolute",top:"calc(100% + 8px)",left:0,background:"#1A2F6B",borderRadius:8,minWidth:300,zIndex:300,boxShadow:"0 8px 32px rgba(8,21,64,0.35)",overflow:"hidden",animation:"pageFade .18s ease"}}>
                      {TRAINING_DROPDOWN.map((item, i) => (
                        <button key={i} onClick={() => !item.soon && handleTrainingItem(item.sub)}
                          style={{display:"block",width:"100%",textAlign:"left",background:"none",border:"none",padding:"16px 20px",cursor:item.soon?"default":"pointer",borderBottom:i<TRAINING_DROPDOWN.length-1?"1px solid rgba(255,255,255,0.07)":"none",transition:"background .15s"}}
                          onMouseEnter={e=>{if(!item.soon)e.currentTarget.style.background="rgba(255,255,255,0.06)";}}
                          onMouseLeave={e=>{e.currentTarget.style.background="none";}}>
                          <span style={{fontFamily:"Arial,Helvetica,sans-serif",fontSize:14,fontWeight:item.soon?400:600,color:item.soon?"rgba(255,255,255,0.4)":"#ffffff",display:"block",lineHeight:1.35}}>{item.label}</span>
                          {item.soon && <span style={{fontFamily:"Arial,Helvetica,sans-serif",fontSize:11.5,color:"rgba(255,255,255,0.35)",marginTop:2,display:"block"}}>Coming Soon</span>}
                        </button>
                      ))}
                    </div>
                  )}
                </div>
              );
            }
            const active = isActive(p);
            return (
              <Link
                key={p}
                to={PAGE_ROUTES[p]}
                className={`nav-item${active?" active":""}`}
                style={{
                  color: active ? C.goldLight : "rgba(255,255,255,0.85)",
                  textDecoration:"none",
                  paddingBottom:6,
                  borderBottom: active ? `2px solid ${C.goldLight}` : "2px solid transparent",
                  transition:"border-color .2s, color .2s",
                }}
                onMouseEnter={e=>{ if(!active){ e.currentTarget.style.borderBottomColor = C.goldLight; e.currentTarget.style.color = C.goldLight; } }}
                onMouseLeave={e=>{ if(!active){ e.currentTarget.style.borderBottomColor = "transparent"; e.currentTarget.style.color = "rgba(255,255,255,0.85)"; } }}
              >
                {p}
              </Link>
            );
          })}
        </div>

        <button onClick={() => setMobileOpen(!mobileOpen)}
          style={{background:"none",border:"none",cursor:"pointer",padding:8,borderRadius:6,display:"none"}}
          className="mobile-menu-btn">
          <div style={{width:22,height:2,background:C.white,marginBottom:5,borderRadius:2}}/>
          <div style={{width:22,height:2,background:C.white,marginBottom:5,borderRadius:2}}/>
          <div style={{width:22,height:2,background:C.white,borderRadius:2}}/>
        </button>
      </div>

      {mobileOpen && (
        <div style={{background:C.navyDark,borderTop:`1px solid rgba(255,255,255,0.08)`,padding:"12px 20px"}}>
          {PAGES.map(p => {
            if (p === "Training") {
              return (
                <div key={p}>
                  <div style={{padding:"10px 12px",fontFamily:"Arial,Helvetica,sans-serif",fontSize:13,fontWeight:700,color:"rgba(255,255,255,0.5)",letterSpacing:1,textTransform:"uppercase"}}>Training</div>
                  {TRAINING_DROPDOWN.map((item,i) => (
                    <button key={i} onClick={() => !item.soon && handleTrainingItem(item.sub)}
                      style={{display:"block",width:"100%",textAlign:"left",background:"none",border:"none",cursor:item.soon?"default":"pointer",padding:"9px 12px 9px 24px",fontFamily:"Arial,Helvetica,sans-serif",fontSize:13.5,color:item.soon?"rgba(255,255,255,0.35)":"rgba(255,255,255,0.85)",borderRadius:6,marginBottom:2}}>
                      {item.label}{item.soon ? " (Coming Soon)" : ""}
                    </button>
                  ))}
                </div>
              );
            }
            const active = isActive(p);
            return (
              <Link key={p} to={PAGE_ROUTES[p]} onClick={() => setMobileOpen(false)}
                style={{display:"block",width:"100%",textAlign:"left",background:"none",border:"none",cursor:"pointer",padding:"10px 12px",fontFamily:"Arial,Helvetica,sans-serif",fontSize:14,color:active?C.goldLight:"rgba(255,255,255,0.8)",fontWeight:active?600:400,borderRadius:6,marginBottom:2,textDecoration:"none"}}>
                {p}
              </Link>
            );
          })}
        </div>
      )}
    </nav>
  );
}